<main class="container-fluid p-1 main-coil">
  <p-splitter styleClass="sec-h" layout="vertical" [style]="{ 'height': '89vh', 'margin': '24px' , 'margin-bottom':'0px' }" [minSizes]="[50, 50]">
    <!--***************************************************************Top Panel*************************************************************************-->
    
    <ng-template pTemplate>
      @if (searchResults) {
        <section class="px-3 py-1 w-100 h-100" style="min-height: 370px;">
          <div class="row">
            <div class="search-group col-lg-4">
              <app-company-dropdown (companySelection)="comapnySelectionChange($event)"></app-company-dropdown>
            </div>
            <div class="search-group col-lg-6">
             
            </div>
            <div class="col-lg-2">
              
            </div>
          </div>
          <div class="row">
            <div class="content col d-flex justify-content-between">
             

              <div class="search-group">
                <app-search-bar style="margin-right: -80px;" (search)="onSearch($event)" [searchText]="searchText" selected="1"/>
                
                @if (selectedCoils.length > 0) {
                  <div class="dropdown" >
                    <a class="coil-compare-button btn btn-sm d-flex align-items-center"
                      style="font-weight: bold; margin-top: 3px;" 
                      href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      {{ selectedCoils.length }} selected &nbsp; <i class="material-icons-outlined" style="display: inline-block">keyboard_arrow_down</i>
                    </a>
                  

                    <div class="dropdown-menu">
                        @for (item of selectedCoils; track $index) {
                          <div  class="dropdown-item" style="font-size: 14px; display: inline-block">{{ item.coilSheetId }}
                            <button class="coil-compare-button btn btn-sm d-flex align-items-center" 
                                    style="font-weight: bold;float:right; height: 20px; padding: 2px" pButton (click)="clearItemSelection([item], $event)">
                                    <i class="material-icons-outlined" style="font-size: 18px;">close</i>
                            </button>
                          </div>
                        }
                      <button class="clear-selection btn btn-primary align-items-center" (click)="clearSelection()">
                          Clear selection
                      </button>
                    </div>
                  </div>
                  <span class="d-flex align-items-center" style="color:lightgray; margin-left: 0.5rem;">| &nbsp;</span>
                  <button style=" width: 200px;
    word-wrap: break-word;" [disabled]="selectedCoils.length < 2 || selectedCoils.length > 5" class="coil-compare-button btn btn-sm d-flex align-items-center" 
                          style="font-weight: bold;" pButton (click)="showDialog()">
                          <i class="material-icons-outlined" style="display: inline-block">compare_arrows</i>&nbsp;Compare&nbsp;
                          @if (selectedCoils.length < 2) { <span style="display: inline-block; margin-top: 2px;">(Select minimum 2 coils)</span>}
                          @if (selectedCoils.length > 5) { <span style="display: inline-block; margin-top: 2px;">(Select maximum 5 coils)</span>}
                  </button>
                }
               
                      
                    
                
                
              </div>
              
                @if (selectedCoils && selectedCoils.length > 0 && showCoilComparisonDialog) {
                  <app-coil-comparison [showCoilComparisonDialog]="showCoilComparisonDialog" (displayChange)="onDialogClose($event)"></app-coil-comparison>
                }
                <app-pagination-bar 
                [odin]="false"
                  [firstPage]="searchResults.first"
                  [lastPage]="searchResults.last"
                  [totalElement]="searchResults.numberOfElements"
                  [pageSize]="searchResults.size"
                  [totalPages]="searchResults.totalPages"
                  [totalElements]="searchResults.totalElements"
                  [currentPage]="searchResults.number"
                  [from]="(searchResults.number*searchResults.size) + 1"
                  [to]="(searchResults.number*searchResults.size) + searchResults.numberOfElements"
                  (startPage)="doCoilPageSearch(0)"
                  (finalPage)="doCoilPageSearch(searchResults.totalPages - 1)"
                  (previousPage)="doCoilPageSearch(searchResults.number-1)"
                  (nextPage)="doCoilPageSearch(searchResults.number+1)">
                </app-pagination-bar>
            </div>
          </div>
          <div class="row" style="height: 94%;">
            <div class="col">
              <ag-grid-angular
                style="height: 82%; border: 0; margin-top: 0.5rem;"
                class="ag-theme-quartz"
                [rowData]="regeneratedCoils"
                [columnDefs]="colDefs"
                [rowSelection]="rowSelection"
                [gridOptions]="gridOptions"
                (gridReady)="onGridReady($event)"
                (selectionChanged)="onSelectionChanged()"
                (sortChanged)="onSortChanged($event)"
                (modelUpdated)="onModelUpdated($event)">
              </ag-grid-angular>
            </div>
          </div>
        </section>
      }
    </ng-template>
    <ng-template pTemplate>
      <!--***************************************************************Bottom left Panel*************************************************************************-->
      <p-splitter [panelSizes]="[50, 50]">
        <ng-template pTemplate>
            <section class="p-3 w-100">
              @if (showOrderDetail && rowDataCoil.length > 0) {
                <div>
                  <div style="display: flex;"><mat-icon class="back-icon" (click)="returnCoilDetail()">keyboard_backspace</mat-icon><span class="order-details-title">Order details</span></div>
                  <app-order-detail [selectedCoil]="selectedCoil" [order]="relatedOrder" [rowDataCoil]="rowDataCoil" [hideTitle]="true" (exportAllData)="onExportAllData()" (coilSelectionChanged)="onCoilSelectionChanged($event)" (coilNrClicked)="onCoilCellClicked($event)"></app-order-detail>
                </div>
                
              } @else {
                <app-coil-detail [coil]="selectedCoil" [order]="relatedOrder" (viewOrderDetail)="onViewOrderDetail()"></app-coil-detail>
              }
            </section>
        </ng-template>
        <!--***************************************************************Bottom Right Panel*************************************************************************-->
        <ng-template pTemplate>
         
          <section class="p-3 w-100">
           
            @if (selectedCoil) {
              @if (selectedCoil && selectedCoil.availableDataSetNames && selectedCoil.availableDataSetNames.length > 0) {
              <app-coil-analytics [coil]="selectedCoil"></app-coil-analytics>
              }
              @else {
                <p style="font-size: 12px; color: black">This Coil has no dataset to show...</p>
                <div class="d-flex justify-content-center align-items-center h-100">
                  <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
                </div>
              }
            } @else {
              <p style="font-size: 12px; color: black">This Coil has no dataset to show...</p>
              <div class="d-flex justify-content-center align-items-center h-100">
                <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
              </div>
            }
          </section>
        </ng-template>
      </p-splitter>
    </ng-template>
  </p-splitter>
  <app-disclaimer [(showDisclaimerDialog)]="shouldShowDisclaimer" (showDisclaimerDialogChange)="onDisclaimerAccepted($event)"></app-disclaimer>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</main>
